(function () {
  'use strict';

  var MAX_RETRIES = 10;
  var RETRY_DELAY = 300;
  var LOG_PREFIX = '[Anber dots]';
  var SECTION_KEYS = [
    'best-sellers',
    'new-arrivals',
    'for-her',
    'for-him',
    'unisex-carousel',
    'gift-carousel',
    'top-sellers'
  ];

  function log(sectionKey, message) {
    if (window.console && window.console.debug) {
      window.console.debug(LOG_PREFIX, '[' + sectionKey + ']', message);
    }
  }

  function initDots(sectionEl, sectionKey) {
    var slider = sectionEl.querySelector('slider-component');
    var counterEl = sectionEl.querySelector('.slider-counter');

    if (!slider || !counterEl) {
      log(sectionKey, 'no se encontro el slider o el contador dentro de la seccion.');
      return;
    }

    if (typeof slider.totalPages === 'undefined') {
      window.setTimeout(function () {
        initDots(sectionEl, sectionKey);
      }, RETRY_DELAY);
      return;
    }

    var buttons = [];

    function setActive(page) {
      if (!buttons.length) {
        return;
      }
      var index = Math.min(Math.max(page - 1, 0), buttons.length - 1);
      buttons.forEach(function (button, i) {
        var isActive = i === index;
        button.classList.toggle('slider-counter__link--active', isActive);
        if (isActive) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    }

    function rebuild() {
      var totalPages = slider.totalPages;
      counterEl.innerHTML = '';
      buttons = [];

      // Todo cabe en una sola pantalla: no hacen falta puntos de navegacion.
      if (!totalPages || totalPages < 2) {
        counterEl.style.display = 'none';
        return;
      }

      counterEl.style.display = '';
      counterEl.classList.add('slider-counter--dots');

      var wrapper = document.createElement('div');
      wrapper.className = 'slideshow__control-wrapper';

      for (var i = 0; i < totalPages; i++) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'slider-counter__link slider-counter__link--dots link';
        button.setAttribute('aria-label', 'Ir al grupo ' + (i + 1) + ' de ' + totalPages);

        var dot = document.createElement('span');
        dot.className = 'dot';
        button.appendChild(dot);

        button.addEventListener(
          'click',
          (function (pageIndex) {
            return function () {
              slider.setSlidePosition(pageIndex * slider.sliderItemOffset);
            };
          })(i)
        );

        wrapper.appendChild(button);
        buttons.push(button);
      }

      counterEl.appendChild(wrapper);
      setActive(slider.currentPage || 1);
    }

    rebuild();

    // El propio slider-component nativo dispara este evento cada vez
    // que cambia de pagina (autoplay, drag manual o click en un punto).
    slider.addEventListener('slideChanged', function (event) {
      setActive(event.detail.currentPage);
    });

    var resizeTimeoutId = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimeoutId);
      resizeTimeoutId = window.setTimeout(rebuild, 200);
    });

    log(sectionKey, 'puntos listos (' + (slider.totalPages || 0) + ' en total).');
  }

  function tryInit(sectionKey, attempt) {
    var section = document.querySelector('[id$="__' + sectionKey + '"]');

    if (!section) {
      if (attempt < MAX_RETRIES) {
        window.setTimeout(function () {
          tryInit(sectionKey, attempt + 1);
        }, RETRY_DELAY);
      } else {
        log(sectionKey, 'no se encontro la seccion tras varios intentos.');
      }
      return;
    }

    initDots(section, sectionKey);
  }

  function init() {
    SECTION_KEYS.forEach(function (sectionKey) {
      tryInit(sectionKey, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
